import React from 'react';
import {documentTypes} from '../../../../../../../util/uiconstants';
import AccountNameWithCreate from './AccountNameWithCreate';
export default function AccountNameCellRenderer(params) {
	const data = params.data;
	const accountName = params.value;

	let relatedDocuments = [];
	if (data && data.relatedDocuments && data.relatedDocuments.length > 0) {
		relatedDocuments = data.relatedDocuments.filter((doc) => doc.documentTypeID === documentTypes.ALRA_INDIVIDUAL);
	}

	return (
		<AccountNameWithCreate
			relatedDocuments={relatedDocuments}
			name={accountName}
			hasEstimate={data?.hasEstimate}
			executionTypeId={data?.executionTypeId}
			accountId={data?.id}
			tooltipRequired={params.tooltipRequired}
		/>
	);
}
